import { useState } from "react";
import { Copy, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/components/Bits";

export const KbDuplicates = ({ onDone }) => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const check = async () => {
    setBusy(true);
    try {
      const r = await api.get("/admin/kb/duplicates");
      if (!r.data.remove_count) toast.success("No duplicates found. Every entry is unique.");
      else setData(r.data);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const remove = async () => {
    setBusy(true);
    try { const r = await api.post("/admin/kb/duplicates/remove"); toast.success(`Removed ${r.data.removed} duplicate ${r.data.removed === 1 ? "entry" : "entries"}`); setData(null); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button onClick={check} disabled={busy} variant="outline" data-testid="kb-dupes-btn" className="rounded-full">
        {busy && !data ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Copy className="h-4 w-4 mr-2" />}Remove duplicates
      </Button>
      <Dialog open={!!data} onOpenChange={(o) => !o && setData(null)}>
        <DialogContent className="max-w-2xl bg-card border-border" data-testid="kb-dupes-dialog">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl">{data?.remove_count} duplicate {data?.remove_count === 1 ? "entry" : "entries"} found</DialogTitle>
            <DialogDescription>These entries have the same title and the same text. The most recently updated copy of each is kept and the others are deleted.</DialogDescription>
          </DialogHeader>
          <ul className="max-h-[50vh] overflow-y-auto space-y-2" data-testid="kb-dupes-list">
            {data?.groups.map((g, i) => (
              <li key={g.keep.id} className="rounded-lg border border-border bg-white p-3 text-sm" data-testid={`kb-dupe-group-${i}`}>
                <div className="font-medium text-navy">{g.title}</div>
                <div className="text-xs text-muted-foreground mt-1">Keeping the copy updated {fmtDate(g.keep.updated_at)} · removing {g.remove.length} {g.remove.length === 1 ? "copy" : "copies"}</div>
              </li>
            ))}
          </ul>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => setData(null)} data-testid="kb-dupes-cancel" className="rounded-full">Cancel</Button>
            <Button onClick={remove} disabled={busy} data-testid="kb-dupes-confirm" className="rounded-full bg-rose-600 hover:bg-rose-700 text-white">
              {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Remove {data?.remove_count} duplicates
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
